import React from "react";

const NavLinks = ({ svg, text, onClick }) => {
  return (
    <div className="navPrompt" onClick={onClick}>
      {svg}
      <p>{text}</p>
    </div>
  );
};

export default NavLinks;
